// console.log("Hello from app/javascript/maps/index.js")

import L from "leaflet";
import { imageMapLayer, identifyImage } from "esri-leaflet";

// Fix missing marker icons when bundling (optional but common)
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
});

/**
 * Renders AAFC Soil Great Group Taxonomy (ImageServer) over a basemap.
 * @param {string|HTMLElement} target - DOM id (string) or element
 * @param {object} opts
 */
export function renderSoilGreatGroupTaxonomyMap(target, opts = {}) {
    const el = typeof target === "string" ? document.getElementById(target) : target;
    if (!el) return;

    const {
        center = [60, -100], // Canada-ish
        zoom = 4,
        opacity = 0.55,
        imageServerUrl = "https://agriculture.canada.ca/imagery-images/rest/services/soil_landscape_grids_100m/soil_great_group_taxonomy/ImageServer",
    } = opts;

    // Avoid double-initializing if Turbo navigates back
    if (el.dataset.leafletInitialized === "true") return;
    el.dataset.leafletInitialized = "true";

    const map = L.map(el, {
        center,
        zoom,
        zoomControl: true,
    
    });

    // Basemap (OSM)
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        maxZoom: 19,
        attribution: "&copy; OpenStreetMap contributors",
    }).addTo(map);

    // AAFC ImageServer overlay
    const soilLayer = imageMapLayer({
            url: imageServerUrl,
            opacity,
            // You can pass ImageServer rendering params here if needed:
            // renderingRule: {...},
            // mosaicRule: {...},
        })
        .addTo(map);

    // Optional: show value on click (uses identify)
    map.on("click", async (e) => {
        try {
            const res = await L.esri
                .identifyImage({
                url: imageServerUrl,
                })
                .at(e.latlng)
                .run();

            // Response format varies by service; usually res.value / res.properties etc.
            const value =
                res?.value ??
                res?.properties?.value ??
                res?.results?.[0]?.value ??
                JSON.stringify(res);

            L.popup()
                .setLatLng(e.latlng)
                .setContent(`<div style="max-width:320px"><b>Soil value:</b> ${value}</div>`)
                .openOn(map);
        } catch (err) {
            // Identify may be disabled for some services; ignore silently
            // console.warn(err);
        }
    });

    return { map, soilLayer };
}
